import React, { useState } from "react";
import { Modal, Form, Row, Col, Input, message } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { ICompetenceType } from "./types";
import { saveOrUpdate } from "../actions/dimensionsAndType";
const { TextArea } = Input;

interface IProps extends FormComponentProps {
    record?: ICompetenceType;
    onClose: (reload?: boolean) => void;
}

function FormCompetenceType({ record, form, onClose }: IProps) {
    const [isSaving, setIsSaving] = useState(false);

    function handleOk() {
        form.validateFields((err, values) => {
            if (!err) {
                setIsSaving(true);

                const objToSave = record
                    ? {
                          id_tipo_competencia: record.id_tipo_competencia,
                          activo: true,
                          versao: record.versao !== "" ? record.versao + 1 : 1,
                      }
                    : {
                          versao: 1,
                      };

                const data = JSON.stringify({
                    tipo_competencia: {
                        ...values,
                        ...objToSave,
                        activo: true,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_tipos_competencias.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const { getFieldDecorator } = form;
    const title = record ? "Editar tipo de competência" : "Novo tipo de competência";

    return (
        <Modal title={title} visible onOk={handleOk} onCancel={() => onClose()} width="50%" confirmLoading={isSaving}>
            <Form layout="vertical" onSubmit={handleOk}>
                <Row gutter={18}>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Designação">
                            {getFieldDecorator("designacao", {
                                initialValue: record?.designacao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Descrição">
                            {getFieldDecorator("descricao", {
                                initialValue: record?.descricao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<TextArea rows={4} />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export const WrappedFormCompetenceType = Form.create<IProps>({
    name: "form_Competence_type",
})(FormCompetenceType);
